import { makeAutoObservable, runInAction } from "mobx";
import {
  listSwayyProductActivityLogs,
  normalizeSwayyApiError,
  SwayyApiError,
} from "../api/SwayyProductsAPI";
import { SwayyProductActivityLog } from "../models/products/SwayyProductActivityLog";

export class SwayyProductActivityLogsStore {
  logs: SwayyProductActivityLog[] = [];
  limit = 20;
  offset = 0;
  total = 0;
  isLoading = false;
  errorMessage = "";

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get page(): number {
    return Math.floor(this.offset / this.limit) + 1;
  }

  get totalPages(): number {
    if (this.total <= 0) return 0;
    return Math.ceil(this.total / this.limit);
  }

  loadLogs = async (
    productId: number,
    offset: number = 0,
  ): Promise<SwayyApiError | null> => {
    this.isLoading = true;
    this.errorMessage = "";
    try {
      const response = await listSwayyProductActivityLogs(productId, {
        limit: this.limit,
        offset,
      });
      runInAction(() => {
        this.logs = response.data;
        this.total = response.pagination.total;
        this.limit = response.pagination.limit;
        this.offset = response.pagination.offset;
        this.isLoading = false;
      });
      return null;
    } catch (error) {
      const apiError = normalizeSwayyApiError(
        error,
        "Unable to load activity logs.",
      );
      runInAction(() => {
        this.isLoading = false;
        this.errorMessage = apiError.message;
        this.logs = [];
        this.total = 0;
      });
      return apiError;
    }
  };

  reset = () => {
    this.logs = [];
    this.offset = 0;
    this.total = 0;
    this.isLoading = false;
    this.errorMessage = "";
  };
}
